
    import * as React from 'react';

    const Link20 = ({ color = 'currentcolor', height = '20px', width = '20px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 20 20" fill="none" style={svgStyle}><rect x={14.8613} y={1.42635} width={5.25} height={7.75} transform="rotate(45 14.8613 1.42635)" stroke="#191A1B" /><rect x={6.90649} y={9.3813} width={5.25} height={7.75} transform="rotate(45 6.90649 9.3813)" stroke="#191A1B" /><path d="M6.02259 13.9775L13.9775 6.02252" stroke="#191A1B" /></svg>
        </div>
      );
    };

    Link20.displayName = 'Link20';

    export default Link20;
  